import Mask from './components/mask';
import { disableScroll, enableScroll } from './helper/helper';

(function ($) {
	let menuOpen = false;
	const menu = $('#site-navigation');
	const mask = new Mask('menu', {}, closeMenu);
	$('.main-navigation--mobile .close_button').on('click', closeMenu);
	$('.menu-open-toggle').on('click', function () {

		const megamenu = $('.max-mega-menu').data('maxmegamenu');

		if (!menu || !megamenu || !megamenu.isMobileView()) {
			return;
		}

		if (menuOpen) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	function closeMenu() {
		gsap.to(menu, {
			x: '100%', onStart: () => {
				document.documentElement.style.overflow = 'visible';
				enableScroll();
			}
		});
		mask.hide();
		menuOpen = false;
	}

	function openMenu() {
		gsap.to(menu, {
			x: 0, onStart: () => {
				document.documentElement.style.overflow = 'hidden';
				disableScroll();
			}
		});
		menuOpen = true;
		mask.show();
	}
}(jQuery));